/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleCalendarioState.js";
import mutations from "./moduleCalendarioMutations.js";
import actions from "./moduleCalendarioActions.js";
import getters from "./moduleCalendarioGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
